import React, { useState, useEffect, useRef } from "react";
import { BASE_URL } from "../../config/axios";
import axios from "axios";
import { AddwithWhiteCircle, DropdownArrow, SearchBig, UpdatePencil, PDFIcon, DeleteDustbin, Attachment, Eye, Documentation, Percentage } from "../AllSvg";
import Select from "react-select";
import { ViewEmployeeList } from "../CustomFunctions";
import { DocumentSection } from "../FormdataComponent";
import { handleErrorToast } from "../CustomFunctions";
import { toast, ToastContainer } from 'react-toastify';
import { StructureFlyovertable } from "../Project/StructureTable";
import { AddActivity, EditDepartment, DepartmentDelete, AddTask, AddSubActivity, SubActivityModal, AddActivityPercentege } from "../Project/AllProjectdetailsmodal";
import { Modal, Button } from "react-bootstrap";
import { DocumentModel } from "./DocumentModel";







const UpdateWeightage = ({
    i,
    getData,
    divisionHead,
    divisionHeadName,
    TLCode,
    TLName,
    empCode,
    empName,
}) => {
    const [show, setShow] = useState(false);
    const [status, setStatus] = useState("pending");
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        activity_details: [
            {
                name: "",
                weightage_percentage: "",
                status: "",
                code: "",
                document: [],
            },
        ],
    });

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    /** Validation */
    const validateform2 = () => {
        const newErrors = {};
        // Add validations as needed
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    /** Open modal and load data */
    const handleShow = () => {
        setShow(true);
        setFormData(i); // load data passed as props
    };

    /** Close modal and reset */
    const handleClose = () => {
        setShow(false);
        setFormData({
            activity_details: [
                {
                    name: "",
                    weightage_percentage: "",
                    status: "",
                    code: "",
                    document: [],
                },
            ],
        });
        setErrors({});
        setInputState({});
    };

    /** Handle input change (number, text, select) */
    const handleFieldChange = (index, field, value) => {
        const newActivityDetails = [...formData.activity_details];

        if (field === "weightage_percentage") {
            const weight = Number(value);
            const totalOtherweightage = newActivityDetails.reduce((sum, activity, i2) => {
                if (i2 !== index) return sum + Number(activity.weightage_percentage || 0);
                return sum;
            }, 0);

            if (totalOtherweightage + weight > 100) {
                setErrors({
                    ...errors,
                    weightage_percentage: "Total weightage percentage cannot exceed 100%",
                });
                setInputState({
                    ...inputState,
                    [`weightage_percentage_${index}`]: "error",
                });
                return;
            } else {
                setErrors({ ...errors, weightage_percentage: "" });
                setInputState({
                    ...inputState,
                    [`weightage_percentage_${index}`]: "success",
                });
            }

            newActivityDetails[index].weightage_percentage = weight;
        } else {
            newActivityDetails[index][field] = value;
        }

        setFormData({ ...formData, activity_details: newActivityDetails });
    };

    /** Handle file change */


    /** Submit Form */
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateform2()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);

            try {

                let res = await axios.put(
                    `${BASE_URL}/detail-design/highwaydepartment/${i.id}/`, formData

                );

                if (res.status === 200) {
                    toast.success("Activity updated successfully!");
                    handleClose();
                    getData();
                } else {
                    toast.error("Failed to update activity!");
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <div>
            <button
                title=""
                style={{ margin: 0 }}
                className="upload-svg"
                onClick={handleShow}
            >
                Update Weightage
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
                <Modal.Header closeButton>
                    <Modal.Title>Update Activity Weightage</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="form-flex-wrap">
                        {formData.activity_details.map((activity, index) => (
                            <React.Fragment key={index}>
                                {/* Activity Name */}
                                <div className="flex-column">
                                    <label className="form-labels">Activity Name</label>
                                    <input
                                        type="text"
                                        value={activity.name}
                                        readOnly
                                        className="form-input-date read-only"
                                    />
                                </div>

                                {/* Weightage Percentage */}
                                <div className="flex-column">
                                    <label className="form-labels">Weightage Percentage</label>
                                    <input
                                        type="number"
                                        min="0"
                                        max="100"
                                        value={activity.weightage_percentage}
                                        onChange={(e) =>
                                            handleFieldChange(index, "weightage_percentage", e.target.value)
                                        }
                                        className={`form-input-date width-15vw ${inputState[`weightage_percentage_${index}`] === "error"
                                            ? "error"
                                            : inputState[`weightage_percentage_${index}`] === "success"
                                                ? "success"
                                                : ""
                                            }`}
                                        placeholder="Enter weightage percentage"
                                    />
                                </div>

                                {/* Status Dropdown */}
                                <div className="flex-column">
                                    <label className="form-labels">Status</label>
                                    <select
                                        value={activity.status}
                                        onChange={(e) =>
                                            handleFieldChange(index, "status", e.target.value)
                                        }
                                        className="form-input width-15vw form-group-selection"
                                    >
                                        <option value="pending">Pending</option>
                                        <option value="completed">Completed</option>
                                    </select>
                                    {errors.selectinput && (
                                        <span className="error-message font-size-text">
                                            {errors.selectinput}
                                        </span>
                                    )}
                                </div>


                            </React.Fragment>
                        ))}

                        {/* Global Error */}
                        {errors.weightage_percentage && (
                            <div style={{ color: "red", fontSize: "13px", marginTop: "5px" }}>
                                {errors.weightage_percentage}
                            </div>
                        )}
                    </div>

                    <div className="button-models" style={{ width: "100%" }}>
                        <button
                            onClick={handleSubmit}
                            className="model-button font-weight500 model-button-submit"
                            disabled={loading}
                        >
                            {loading ? "Submitting..." : "Submit"}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};


const UpdateSubWeightage = ({ i, parentId, getData, employeeData, id }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    // ✅ formData is always an array
    const [formData, setFormData] = useState({

        subactivity: [
            {
                weightage: "",
                start_date: null,
                end_date: null,
                assign_to: [],
                status: "",
            },
        ],

    },
    );

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [allEmployeeData, setAllEmployeeData] = useState([]);

    console.log("i")
    console.log(i)

    const filterSubActivity = i?.subactivity

    const displayedSubactivities = (formData.subactivity || []).filter(
        (item) => item.activity_id === parentId
    );

    // console.log("filterSubActivity")
    // console.log(filterSubActivity)

    // console.log("displayedSubactivities")
    // console.log(displayedSubactivities)



    /** =============================
     * VALIDATION
     * ============================= */
    const validateform = () => {
        const newErrors = {};

        // Ensure subactivity exists and is an array
        (displayedSubactivities || []).forEach((activity, index) => {
            if (!activity.start_date) {
                newErrors[`start_date_${index}`] = "Start date is required!";
            }
            if (!activity.end_date) {
                newErrors[`end_date_${index}`] = "Submission date is required!";
            }
            if (!activity.assign_to || activity.assign_to.length === 0) {
                newErrors[`assign_to_${index}`] = "Assigned employee is required!";
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // returns true if no errors
    };


    /** =============================
     * OPEN MODAL
     * ============================= */
    const handleShow = () => {
        setShow(true);

        setFormData((prev) => ({
            ...prev,
            subactivity: [
                ...prev.subactivity.filter(
                    (item) => !filterSubActivity.some((f) => f.id === item.id)
                ),
                ...filterSubActivity,
            ],
        }));
    };



    /** =============================
     * CLOSE MODAL
     * ============================= */
    const handleClose = () => {
        setShow(false);
        setFormData({
            subactivity: [
                {
                    weightage: "",
                    start_date: null,
                    end_date: null,
                    assign_to: [],
                    status: "",
                },
            ],
        });

        setErrors({});
        setInputState({});
    };

    /** =============================
     * HANDLE FIELD CHANGE
     * ============================= */

    const handleFieldChange = (index, field, value) => {
        const newActivityDetails = [...formData.subactivity];

        if (field === "weightage") {
            const weight = Number(value);

            // only validate subactivities where activity_id === parentId
            const totalOtherWeightage = newActivityDetails.reduce((sum, activity, i2) => {
                if (
                    i2 !== index &&
                    activity.activity_id === parentId // ✅ only same as parentId
                ) {
                    return sum + Number(activity.weightage || 0);
                }
                return sum;
            }, 0);

            const totalWeightageForParent = totalOtherWeightage + weight;

            if (totalWeightageForParent > 100) {
                setErrors({
                    ...errors,
                    [`weightage_${parentId}`]: "Total weightage percentage for this parent activity cannot exceed 100%",
                });
                setInputState({
                    ...inputState,
                    [`weightage_${index}`]: "error",
                });
                return;
            } else {
                setErrors({
                    ...errors,
                    [`weightage_${parentId}`]: "",
                });
                setInputState({
                    ...inputState,
                    [`weightage_${index}`]: "success",
                });
            }

            // update weightage for this subactivity
            newActivityDetails[index].weightage = weight;
        }
        else {
            newActivityDetails[index][field] = value;
        }

        setFormData({ ...formData, subactivity: newActivityDetails });
    };


    /** =============================
     * ASSIGNED EMPLOYEE HANDLER
     * ============================= */
    const selectEmployee = (selected, index) => {
        setFormData((prevFormData) => {
            const updatedSubactivities = [...prevFormData.subactivity];
            updatedSubactivities[index] = {
                ...updatedSubactivities[index],
                assign_to: selected.map((item) => item.value),
            };

            return {
                ...prevFormData,
                subactivity: updatedSubactivities,
            };
        });
    };


    /** =============================
     * FETCH EMPLOYEE DATA
     * ============================= */
    const [toggleCompany] = useState(sessionStorage.getItem("company_id"));

    const getEmployeeDetails = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`
            );
            setAllEmployeeData(res.data);
        } catch (err) {
            toast.error("Failed to load employee data");
        }
    };

    useEffect(() => {
        getEmployeeDetails();
    }, []);

    /** =============================
     * FILTER EMPLOYEES BASED ON employeeData
     * ============================= */
    const matchedArray = allEmployeeData.filter((item) =>
        employeeData.includes(item.emp_code)
    );

    const employeeOptions = matchedArray
        .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
        .map((e) => ({
            value: e.emp_code,
            label: `${e.emp_code} - ${e.name}`,
        }));

    const savedArray = employeeOptions.map((item, index) => {
        const [emp_code, emp_name] = item.label.split(" - ");
        return {
            id: index + 1,
            emp_code: emp_code,
            emp_name: emp_name,
        };
    });




    console.log("savedArray")

    console.log(savedArray)

    /** =============================
     * PUT savedArray INTO formData[0].assigned_to
     * ============================= */


    /** =============================
     * SUBMIT HANDLER
     * ============================= */
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateform()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);

            try {
                const res = await axios.put(
                    `${BASE_URL}/detail-design/highwaydepartment/${id}/`,
                    formData
                );

                if (res.status === 200) {
                    toast.success("Sub-Activity updated successfully!");
                    handleClose();
                    getData();
                } else {
                    toast.error("Failed to update activity!");
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    console.log("Current formData:", formData);

    /** =============================
     * RENDER
     * ============================= */
    return (
        <div>
            {/* BUTTON TO OPEN MODAL */}
            <button
                title="Update Weightage"
                style={{ margin: 0 }}
                className="upload-svg"
                onClick={handleShow}
            >
                Update Weightage
            </button>

            {/* MODAL */}
            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
                <Modal.Header closeButton>
                    <Modal.Title>Update Sub-Activity</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="form-flex-wrap">
                        {(Array.isArray(formData.subactivity) ? formData.subactivity : []).map((activity, index) => (
                            <React.Fragment key={index}>
                                {activity.activity_id === parentId &&
                                    <>
                                        <div className="flex-column">
                                            <label className="form-labels">Sub-Activity Name</label>
                                            <input
                                                type="text"
                                                value={activity.name || ""}
                                                readOnly
                                                className="form-input-dateee "
                                            />
                                        </div>

                                        <div className="flex-column">
                                            <label className="form-labels">
                                                Assigned To <span className="required">*</span>
                                            </label>
                                            <Select
                                                options={employeeOptions}
                                                isMulti
                                                onChange={(selected) => selectEmployee(selected, index)}
                                                value={activity.assign_to
                                                    ?.map((empCode) => {
                                                        const emp = allEmployeeData.find((e) => e.emp_code === empCode);
                                                        return emp
                                                            ? {
                                                                value: emp.emp_code,
                                                                label: `${emp.emp_code} - ${emp.name}`,
                                                            }
                                                            : null;
                                                    })
                                                    .filter(Boolean)}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: "92%",
                                                        minHeight: "50px",
                                                        borderRadius: "10px",
                                                        border: "1px solid #e3e3e3",
                                                        backgroundColor: "#f4f7fe",
                                                        margin: "10px -10px 0px 10px",
                                                        padding: "5px 5px 0px 5px",
                                                    }),
                                                    valueContainer: (provided) => ({
                                                        ...provided,
                                                        display: "flex",
                                                        flexDirection: "column", // 👈 stack selected values vertically
                                                        alignItems: "flex-start",
                                                    }),
                                                    multiValue: (provided) => ({
                                                        ...provided,
                                                        display: "block", // 👈 make each value take full width
                                                        margin: "2px 0",  // spacing between rows
                                                    }),
                                                    multiValueLabel: (provided) => ({
                                                        ...provided,
                                                        display: "block",
                                                    }),
                                                }}
                                            />

                                            {errors[`assign_to_${index}`] && (
                                                <span className="error-message">
                                                    {errors[`assign_to_${index}`]}
                                                </span>
                                            )}
                                        </div>

                                        <div className="flex-column">
                                            <label className="form-labels">Weightage (%)</label>
                                            <input
                                                type="number"
                                                min="0"
                                                max="100"
                                                value={activity.weightage || ""}
                                                onChange={(e) =>
                                                    handleFieldChange(index, "weightage", e.target.value)
                                                }
                                                className={`form-input-dateee  ${inputState[`weightage_${index}`] === "error"
                                                    ? "error"
                                                    : inputState[`weightage_${index}`] === "success"
                                                        ? "success"
                                                        : ""
                                                    }`}
                                                placeholder="Enter weightage"
                                            />
                                        </div>

                                        <div className="flex-column">
                                            <label className="form-labels">
                                                Start Date <span className="required">*</span>
                                            </label>
                                            <input
                                                type="date"
                                                value={activity.start_date || ""}
                                                onChange={(e) =>
                                                    handleFieldChange(index, "start_date", e.target.value)
                                                }
                                                className={`form-input-dateee ${errors[`start_date_${index}`] ? "error" : ""
                                                    }`}
                                            />
                                            {errors[`start_date_${index}`] && (
                                                <span className="error-message">
                                                    {errors[`start_date_${index}`]}
                                                </span>
                                            )}
                                        </div>

                                        <div className="flex-column">
                                            <label className="form-labels">
                                                Submission Date <span className="required">*</span>
                                            </label>
                                            <input
                                                type="date"
                                                value={activity.end_date || ""}
                                                onChange={(e) =>
                                                    handleFieldChange(index, "end_date", e.target.value)
                                                }
                                                className={`form-input-dateee ${errors[`end_date_${index}`] ? "error" : ""
                                                    }`}
                                            />
                                            {errors[`end_date_${index}`] && (
                                                <span className="error-message">
                                                    {errors[`end_date_${index}`]}
                                                </span>
                                            )}
                                        </div>

                                        <div className="flex-column">
                                            <label className="form-labels">Status</label>
                                            <select
                                                value={activity.status || "pending"}
                                                onChange={(e) =>
                                                    handleFieldChange(index, "status", e.target.value)
                                                }
                                                className="form-input form-input-dateee"
                                            >
                                                <option value="pending">Pending</option>
                                                <option value="completed">Completed</option>
                                            </select>
                                        </div>
                                    </>

                                }

                            </React.Fragment>
                        ))}
                    </div>

                    {/* Weightage Validation */}
                    {errors.weightage && (
                        <div style={{ color: "red", fontSize: "13px", marginTop: "5px" }}>
                            {errors.weightage}
                        </div>
                    )}

                    {/* Submit Button */}
                    <div
                        className="button-models"
                        style={{ width: "100%", marginTop: "20px" }}
                    >
                        <button
                            onClick={handleSubmit}
                            className="model-button font-weight500 model-button-submit"
                            disabled={loading}
                        >
                            {loading ? "Submitting..." : "Submit"}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};


const ShowSubActivities = ({ activity_id, data, activityName, employeeData, id, departmentData, getData, project }) => {
    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false)
    }

    const getSubActivity = data?.subactivity?.map((i) => i);



    const filtersubactivity = getSubActivity?.filter(i => i.activity_id === activity_id);
    console.log(activityName)


    return (
        <>
            <button onClick={handleShow} className="" style={{ color: '#0d6efd' }}>

                View

            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="ourcompany-model"
            >
                <Modal.Header closeButton>
                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                        <Modal.Title>Subactivity Details of {activityName} </Modal.Title>
                        <UpdateSubWeightage i={departmentData}
                            parentId={activity_id}
                            Data={data}
                            id={id}
                            getData={getData}
                            employeeData={employeeData} />
                    </div>


                </Modal.Header>
                <Modal.Body>
                    <div className="table-css-white-background table-box scroll-container-table">

                        <table className="table-css">
                            <thead className="table-heading">
                                <tr className="custom-table-head-tr">
                                    <th className="table-heading-text">Sr no.</th>
                                    <th className="table-heading-text">SubActivity Code </th>
                                    <th className="table-heading-text">SubActivity Name </th>
                                    <th className="table-heading-text">Assinged To</th>
                                    <th className="table-heading-text">Weightage Percentage</th>
                                    <th className="table-heading-text">Start Date</th>
                                    <th className="table-heading-text">Submission Date</th>
                                    <th className="table-heading-text">Documents</th>
                                    <th className="table-heading-text">Status</th>

                                </tr>
                            </thead>
                            <tbody>
                                {filtersubactivity.length > 0 ? (
                                    filtersubactivity.map((i, index) => (
                                        <tr key={i.id || index} className="custom-table-head-td">
                                            <td className="table-body">{index + 1}</td>
                                            <td className="table-body ">{i.code}</td>

                                            <td className="table-body ">{i.name}</td>
                                            <td className="table-body">
                                                {Array.isArray(i.assign_to) && i.assign_to.length > 0
                                                    ? i.assign_to.join(", ")
                                                    : "-"}
                                            </td>
                                            <td className="table-body text-center">{i.weightage}</td>
                                            <td className="table-body ">{i.start_date}</td>
                                            <td className="table-body text-center">{i.end_date}</td>
                                            <td className="table-body text-center">
                                                <DocumentModel subactivityId={i.id} projectiD={project} title="Sub-Activity" />
                                            </td>
                                            <td className="table-body ">{i.status}</td>




                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="">
                                            No Sub-Activity Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )

}


// const [toggleStatechange, setToggleStatechange] = useState(1);
const Department = ({ projectID, departmentData, getDepartmentList, departmentlist, getData }) => {


    // ---------------- Weightage Validation Logic ---------------- //

    // Calculate Remaining Weightage

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="attendance-box">
                <div className="info-box-div-without-bg">
                    <div className="info-box-div-bg">
                        <div className="jd-heading-outer-flex" style={{ alignItems: "center" }}>
                            <div></div>
                            <div className="action-buttons">
                                <EditDepartment
                                    projectId={projectID}
                                    i={departmentData}
                                    getDepartmentList={getDepartmentList}
                                    departmentlist={departmentlist}
                                />
                                <DepartmentDelete
                                    projectId={projectID}
                                    i={departmentData}
                                    getDepartmentList={getDepartmentList}
                                />
                            </div>
                        </div>

                        {/* Department Info Section */}
                        <div className="personal-detail" style={{ width: "100%" }}>
                            <div>
                                <table>
                                    <tbody>
                                        {departmentData?.department_type === "internal" ? (
                                            <div className="division-table">
                                                <div>
                                                    <tr>
                                                        <td className="personal-detail-1 font-weight500 font-size-text">Head Of Division :</td>
                                                        <th className="personal-detail-2 font-weight500 font-size-text">
                                                            {departmentData?.division_head_name || "-"}
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <td className="personal-detail-1 font-weight500 font-size-text">Assigned TL :</td>
                                                        <th className="personal-detail-2 font-weight500 font-size-text">
                                                            {departmentData?.team_lead_name || ""}
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <td className="personal-detail-1 font-weight500 font-size-text">Assigned Designers :</td>
                                                        <th className="personal-detail-2 font-weight500 font-size-text">
                                                            {departmentData?.employee || ""}
                                                        </th>
                                                    </tr>
                                                </div>

                                                <div className="division-table-2">
                                                    <tr>
                                                        <td className="personal-detail-1 font-weight500 font-size-text">Weightage %age* :</td>
                                                        <th className="personal-detail-2 font-weight500 font-size-text">
                                                            {departmentData?.weightage || ""}
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <td className="personal-detail-1 font-weight500 font-size-text">Name Of Division :</td>
                                                        <th className="personal-detail-2 font-weight500 font-size-text">
                                                            {departmentData.division_data?.name}

                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <td className="personal-detail-1 font-weight500 font-size-text">Department :</td>
                                                        <th className="personal-detail-2 font-weight500 font-size-text">
                                                            {departmentData?.department_name || ""}
                                                        </th>
                                                    </tr>
                                                </div>
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    </tbody>
                                </table>
                                <div className="jd-heading-bottom-light-blue"></div>

                                {/* Activities Table */}
                                <div className="info-box-div">
                                    <div
                                        className="jd-heading-outer heading-bg-color-white"
                                        style={{ marginBottom: "10px", marginTop: "10px", width: "100%" }}
                                    >
                                        <div className="jd-heading-outer-flex" style={{ alignItems: "center", marginBottom: "10px" }}>
                                            <div >
                                                <h3 className="jd-heading-main font-weight600 font-size-heading">
                                                    Activity List: {departmentData.division_data?.name}
                                                </h3>

                                            </div>
                                            <UpdateWeightage i={departmentData} />
                                        </div>
                                        <div>
                                            <div className="personal-detail" style={{ width: "100%" }}>
                                                <div>
                                                    <table className="Pro-details">
                                                        <thead>
                                                            <tr style={{ position: "sticky" }}>
                                                                <th>Activity Name</th>
                                                                <th style={{ textAlign: "center" }}>Number Of SubActivity</th>
                                                                <th style={{ textAlign: "center" }}>Weightage</th>
                                                                <th style={{ textAlign: "center" }}>Documentation</th>
                                                                <th style={{ textAlign: "center" }}>View Sub Activities</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                departmentData?.activity_details?.map((i) => (
                                                                    <tr>
                                                                        <td ClassName="personal-detail-1 font-weight500 font-size-text">
                                                                            {i.name}
                                                                        </td>
                                                                        <td ClassName="personal-detail-1" style={{ textAlign: "center" }}>
                                                                            {i.sub_activity_count}
                                                                        </td>
                                                                        <td style={{ textAlign: "center" }}>
                                                                            {i.weightage_percentage ? i.weightage_percentage : "-"}
                                                                        </td>
                                                                        <td style={{ display: "flex", justifyContent: "center" }}>

                                                                            <DocumentModel activityId={i.id} projectiD={departmentData?.project} title="Activity Document" />
                                                                        </td>

                                                                        <td style={{ textAlign: "center" }}>
                                                                            <ShowSubActivities activity_id={i.id} data={departmentData} activityName={i.name} project={departmentData?.project} employeeData={departmentData?.employee} id={departmentData.id} departmentData={departmentData} getData={getDepartmentList} />
                                                                        </td>
                                                                    </tr>

                                                                ))
                                                            }
                                                        </tbody>

                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Remaining Weightage Display */}
                                    <div style={{ marginTop: "10px", textAlign: "right" }}>
                                        <p

                                        >
                                        </p>
                                    </div>
                                </div>
                                <div className="jd-heading-bottom-light-blue"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};


















export default Department;
